import { get } from './client'
import type { Libelles, Widget } from './vues'

/**
 * Surface `engine/tableaux-de-bord` du backend, en LECTURE : un tableau de
 * bord se construit par les outils MCP (`tableau_de_bord_*`), jamais depuis
 * l'écran. Il ne porte aucune donnée : chaque widget se lit sur
 * `/vues/:id/agregats` de SA vue (`agregerVue`), sous les droits du lecteur.
 *
 * Une entrée de navigation AUTONOME, au même rang qu'une vue : racine de la
 * barre latérale, ou onglet d'un conteneur (`parentId`).
 */

export interface ResumeTableauDeBord {
  id: string
  libelles: Libelles
  icone: string
  /** Conteneur dont il est un onglet, ou `null` : la racine de la barre latérale. */
  parentId: string | null
  position: number
}

export interface TableauDeBord extends ResumeTableauDeBord {
  version: number
  /** Ceux que les droits du lecteur ouvrent : le serveur retire les autres. */
  widgets: Widget[]
}

export function listerTableauxDeBord(): Promise<{ tableauxDeBord: ResumeTableauDeBord[] }> {
  return get('/tableaux-de-bord')
}

export function lireTableauDeBord(id: string, signal?: AbortSignal): Promise<TableauDeBord> {
  return get(`/tableaux-de-bord/${encodeURIComponent(id)}`, { signal })
}
